import ClaimPodcastBanner from './ClaimPodcastBannerContainer';

export default ClaimPodcastBanner;
